const BASE_INDEX = 5000

export default {
  namespaced: true,

  state: {
    index: 0,
  },

  actions: {

    show ({ commit, state }) {
      commit('increment')
      return BASE_INDEX + state.index
    },

    hide ({ commit }) {
      commit('decrement')
    },
  },

  mutations: {

    increment (state) {
      state.index++
    },

    decrement (state) {
      if (state.index) {
        state.index--
      }
    },
  },
}
